import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { Sizes, Colours } from '@ratehub/base-ui';


function HighlightContainer({ children, className }) {
    return (
        <div className={classNames('rh-bg-coconut rh-box-sizing-border-box rh-p-2 rh-border-radius-8px', className)}>
            {children}
        </div>
    );
}

HighlightContainer.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

HighlightContainer.blockKey = 'rh/highlight-container';

export default styled(HighlightContainer)`
    width: 100%;    // counter-intuitive, but required when within LayoutRowColumns, it seems
    border: 2px solid ${Colours.BLUEBERRY};

    margin-right: 1vw;  // tends to get clipped at right without this
    box-shadow: ${Colours.BLUEBERRY_LIGHTEST}
        clamp(${Sizes.SPACING.HALF}, 2vw, ${Sizes.SPACING.ONE_AND_A_HALF})
        clamp(${Sizes.SPACING.HALF}, 2vw, ${Sizes.SPACING.ONE_AND_A_HALF});
`;
